export const errorMappings = {
  'ORDER.IMPORT.SHEET_RECORD.EMPTY': 'File yang di pilih belum terisi data untuk di unggah',
}
